import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

import { EmbeddedInput } from '@components/hookFormControllers/FieldPickerController/EmbeddedInput'

import { FIELD_VALUE_TYPE } from '@constants'
import { AutocompleteOption, GETObjectModel } from '@types'

import { GanttFormValues } from '@gantt/components/GanttCreateOrEdit'
import { OptionsFilter } from '@gantt/types'

type FieldPickerControllerProps = {
  isEdit: boolean
  isFlatOptions?: boolean
  name: any
  object?: AutocompleteOption<string> | null
  optionsFilter?: OptionsFilter
  onChange?: (object: GETObjectModel) => void
  onInit?: (object: GETObjectModel) => void
  existingPaths?: string[]
  selectedPaths?: string[]
  refPickAllowed?: boolean
}

export const FieldPickerController = ({
  isEdit,
  isFlatOptions,
  name,
  object,
  optionsFilter,
  existingPaths,
  selectedPaths,
  refPickAllowed,
}: FieldPickerControllerProps) => {
  const { watch, setValue } = useFormContext<GanttFormValues>()

  const watchedEmbeddedObjects: ConfigField[] = watch(name)
  const objectCode = object?.id || object

  useEffect(() => {
    if (!isEdit && !watchedEmbeddedObjects?.at(0)?.objectCode) {
      setValue(name, [{ objectCode, refValueType: FIELD_VALUE_TYPE.OBJ_PK_LINK, field: '' }])
    }
    if (watchedEmbeddedObjects && watchedEmbeddedObjects?.at(0)?.objectCode !== objectCode) {
      setValue(name, [{ objectCode, refValueType: FIELD_VALUE_TYPE.OBJ_PK_LINK, field: '' }])
    }
  }, [objectCode])

  return (
    <>
      {watchedEmbeddedObjects?.map((field, index) => (
        <EmbeddedInput
          key={field.id}
          embeddedObjectPickerControllerName={name}
          existingPaths={existingPaths}
          index={index}
          isFlatOptions={isFlatOptions}
          name={`${name}.${index}`}
          optionsFilter={optionsFilter}
          required={!refPickAllowed}
          selectedPaths={selectedPaths}
          setValue={setValue}
          watchedEmbeddedObjects={watchedEmbeddedObjects}
        />
      ))}
    </>
  )
}
